// extracted by mini-css-extract-plugin
module.exports = {"styledParagraphItem":"styledParagraphItem--6ca81","typeLabel":"typeLabel--741dc","header":"header--33a05"};